'use strict';

var _ = require('lodash');
var AdvancedHepGridService = function AdvancedHepGridService(restangular, GridSettings, SearchCriteriaRule, configurationService, configurationParametersAdvancedService, advancedHepExportToCsvService, featureToggleService) {
  var HEP_TYPES_TO_REMOVE_CARRIER_FILTER = ['FOBusinessRules', 'FOFareClassMapping', 'FORBDLevelFareThreshold', 'FOUpSellBuyDownConfig', 'FOSeasonLevelMatchThreshold', 'FOTacticalFareIndex', 'FOTacticalUserOverrides'];
  function getConfigs(configType) {
    return configurationParametersAdvancedService.getConfigs(configType);
  }
  function isReadOnly(type, level, configType) {
    return getConfigByTypeAndLevel(type, level, configType).readOnly;
  }
  function isShowSelectionCheckboxes(type, level, configType) {
    return getConfigByTypeAndLevel(type, level, configType).showSelectionCheckboxes;
  }
  function areAllColumnsDynamic(config) {
    var result = true;
    _.each(config.properties, function (columnDefinition) {
      if (columnDefinition.columns) {
        _.each(columnDefinition.columns, function (innerColumnDef) {
          if (innerColumnDef.width) {
            result = false;
            return false;
          }
        });
      } else {
        if (columnDefinition.width) {
          result = false;
          return false;
        }
      }
    });
    return result;
  }
  function countColumns(columnDefinitions) {
    var columnsCount = 0;
    if (columnDefinitions) {
      columnsCount = _.sumBy(columnDefinitions, function (property) {
        return property.columns ? property.columns.length : 1;
      });
    }
    return columnsCount;
  }
  function buildDefaultColumn(config, onlyDynamicColumns) {
    var percentage = 'auto';
    if (onlyDynamicColumns) {
      var isCheckboxColumnDisplayed = config.showSelectionCheckboxes === undefined;
      var spaceForAllDataColumns = isCheckboxColumnDisplayed ? 96 : 99;
      var dataColumnsCount = countColumns(config.properties) + countColumns(config.attributes);
      percentage = spaceForAllDataColumns / dataColumnsCount + '%';
    }
    return {
      frozen: false,
      visible: true,
      cellsalign: 'center',
      width: percentage
    };
  }
  var parseAttributes = function parseAttributes(config) {
    var onlyDynamicColumns = areAllColumnsDynamic(config);
    var columns = _.map(config.attributes, function (value) {
      return _.assign(buildDefaultColumn(config, onlyDynamicColumns), value);
    });
    _.each(columns, function (column) {
      if (column.columnvalues) {
        column.field = column.columnvalues;
      }
    });
    var fields = _.map(columns, pick);
    return {
      columns: columns,
      fields: fields
    };
  };
  var parseProperties = function parseProperties(config) {
    var properties = config.properties;
    var onlyDynamicColumns = areAllColumnsDynamic(config);
    switch (config.propertyType) {
      case 'VALUE':
        var columnsValue = _.map(properties, function (field) {
          return _.assign(buildDefaultColumn(config, onlyDynamicColumns), field);
        });
        var fieldsValue = _.map(properties, pick);
        return {
          columns: columnsValue,
          fields: fieldsValue
        };
      case 'GROUP':
        var columnsGroup = _.map(properties, function (group) {
          var columns = _.map(group.columns, function (field) {
            return _.assign(buildDefaultColumn(config, onlyDynamicColumns), field);
          });
          return _.assign(group, {
            columns: columns
          });
        });
        var fieldsGroup = _.chain(properties).map(function (group) {
          return _.map(group.columns, pick);
        }).flatten().uniqWith(_.isEqual).value();
        return {
          columns: columnsGroup,
          fields: fieldsGroup
        };
      case 'VALUE_GROUP':
        var columns = _.map(properties, function (column) {
          if (column.columns) {
            var columns = _.map(column.columns, function (field) {
              return _.assign(buildDefaultColumn(config, onlyDynamicColumns), field);
            });
            return _.assign(column, {
              columns: columns
            });
          } else {
            return _.assign(buildDefaultColumn(config, onlyDynamicColumns), column);
          }
        });
        var fields = _.chain(properties).map(function (column) {
          if (column.columns) {
            return _.map(column.columns, pick);
          } else {
            return _.map([column], pick);
          }
        }).flatten().uniqWith(_.isEqual).value();
        return {
          columns: columns,
          fields: fields
        };
    }
  };
  var pick = function pick(item) {
    var fields = {
      name: item.field,
      type: item.type,
      title: item.title,
      subTypeLabel: item.subTypeLabel
    };
    if (item.percentageFormat) {
      fields.percentageFormat = item.percentageFormat;
    }
    return fields;
  };
  function getConfigByTypeAndLevel(type, level, configType) {
    var filterBy = {
      type: type,
      level: level
    };
    return _.find(getConfigs(configType), filterBy);
  }
  function createSortCriteria(fields) {
    return _.map(fields, function (field) {
      return {
        field: field.name,
        direction: 'asc'
      };
    });
  }
  var getSettings = function getSettings(type, level, configType) {
    var hepConfig = getConfigByTypeAndLevel(type, level, configType);
    var attributes = parseAttributes(hepConfig);
    var properties = parseProperties(hepConfig);
    var gridConfig = _.chain(hepConfig).assign({
      gridId: 'configuration-parameters-advanced',
      drawerMenu: {},
      columns: attributes.columns.concat(properties.columns),
      fields: attributes.fields.concat(properties.fields),
      editable: !hepConfig.readOnly,
      sortCriteria: createSortCriteria(attributes.fields)
    }).omit(['type', 'level', 'attributes', 'properties', 'propertyType', 'description']).value();
    if (!_.includes(_.map(gridConfig.fields, 'name'), 'isNewlyAdded')) {
      gridConfig.fields.push({
        name: 'isNewlyAdded',
        type: 'boolean'
      });
    }
    return _.assign(new GridSettings(gridConfig), {
      isDynamic: true,
      dynamicFields: gridConfig.fields
    });
  };
  var prepareSearchCriteria = function prepareSearchCriteria(type, hierarchy, configType) {
    var searchCriteriaRules = createSearchCriteriaForAttributes(type, hierarchy, configType);
    searchCriteriaRules.push(createRule('type', '=', type));
    return searchCriteriaRules;
  };
  var createSearchCriteriaForAttributes = function createSearchCriteriaForAttributes(type, hierarchy, configType) {
    var attributesForType = getAttributes(type, configType);
    var selectedAttributes = _.split(hierarchy, '.');
    if (HEP_TYPES_TO_REMOVE_CARRIER_FILTER.includes(type)) {
      var hostCarrierIndex = attributesForType.indexOf('hostCarrier');
      if (hostCarrierIndex !== -1) {
        attributesForType.splice(hostCarrierIndex, 1);
      }
    }
    return _.map(attributesForType, function (attr) {
      if (attr === 'foCabin') {
        attr = 'cabin';
      }
      if (attr === 'foCarrier') {
        attr = 'carrier';
      }
      var fieldName = 'attributes.' + attr;
      var value = _.includes(selectedAttributes, attr);
      return createRule(fieldName, 'exists', value);
    });
  };
  var createRule = function createRule(fieldName, operator, leftOperandValue) {
    return new SearchCriteriaRule({
      field: fieldName,
      operator: operator,
      leftOperand: leftOperandValue
    });
  };
  function getDefaultValueForAttribute(type, level, attributeName) {
    var config = getConfigByTypeAndLevel(type, level);
    if (!config) {
      return undefined;
    }
    return _.chain(config.attributes).filter(function (attribute) {
      return attribute.field === attributeName;
    }).map(function (attribute) {
      return attribute.defaultValue;
    }).head().value();
  }
  function getAttributesByType(attributeType) {
    return _.chain(getConfigs()).flatMap(function (config) {
      return config.attributes;
    }).filter(function (attribute) {
      return attribute.type === attributeType;
    }).uniqBy(function (e) {
      return e.field;
    }).value();
  }
  function getAttributes(type, configType) {
    return _.chain(getConfigs(configType)).filter({
      'type': type
    }).flatMap(function (config) {
      var attrs = _.chain(config.attributes).filter(function (attr) {
        return _.has(attr, 'visible') ? attr.visible : true;
      }).map('field').value();
      return _.includes(config.level, 'legId') ? _.concat(['legId'], _.without(attrs, 'airlineCode', 'flightNumber', 'departureDate', 'origin', 'destination')) : attrs;
    }).uniq().value();
  }
  function attachAttributes(type, attributes) {
    switch (type) {
      case 'DA_FareFloorCeiling':
        return _.concat(attributes, ['minAP', 'maxAP']);
    }
    return attributes;
  }
  function getAttributesForDuplicateValidation(type, configType) {
    var attributes = getAttributes(type, configType);
    if (configType === 'DYNAMIC_AVAILABILITY') {
      attributes = _.map(attributes, function (attr) {
        return attr === 'pos' ? 'daPos' : attr;
      });
    }
    return attachAttributes(type, attributes);
  }
  function getConfigProperty(type, configType) {
    var configHierarchies = _.filter(getConfigs(configType), {
      type: type
    });
    var configHierarchy = _.first(configHierarchies);
    return _.get(configHierarchy, 'property');
  }
  function getCsvExportOrder(type) {
    var csvExportOrder = _.cloneDeep(configurationParametersAdvancedService.getCsvExportOrder(type));
    if (!csvExportOrder) {
      throw new Error('CSV Export Order not defined for:' + type);
    }
    addCalculatedColumns(csvExportOrder);
    return _.filter(csvExportOrder.columns, function (column) {
      return _.isUndefined(column.exportIfFeature) || featureToggleService.isEnabled(column.exportIfFeature);
    });
  }
  function addCalculatedColumns(csvExportOrder) {
    _.each(csvExportOrder.columns, function (column) {
      if (column.nested) {
        var newNestedColumns = [];
        _.each(column.nested, function (nestedColumn) {
          if (nestedColumn.calculateForAll === 'cabins') {
            newNestedColumns.push.apply(newNestedColumns, prepareColumnsForAllCabins(nestedColumn));
          } else {
            newNestedColumns.push(nestedColumn);
          }
        });
        column.nested = newNestedColumns;
      }
    });
  }
  function prepareColumnsForAllCabins(column) {
    return _.map(configurationService.getCabins(), function (cabin) {
      var newColumn = _.clone(column);
      newColumn.label = cabin;
      newColumn.name = newColumn.name + cabin;
      return newColumn;
    });
  }
  function isNestedProperty(type) {
    var csvConfig = configurationParametersAdvancedService.getCsvExportOrder(type);
    return !_.chain(csvConfig.columns).find(function (column) {
      return !_.isUndefined(column.nested);
    }).isUndefined().value();
  }
  function getExportDataFunction(type) {
    if (type === 'FP_MarketConfig') {
      return advancedHepExportToCsvService.createFpMarketConfigExportData;
    } else if (type === 'FOTacticalUserOverrides') {
      return advancedHepExportToCsvService.createFOTacticalUserOverridesExportData;
    } else if (isNestedProperty(type)) {
      return advancedHepExportToCsvService.createNestedPropertiesExportData;
    } else {
      return advancedHepExportToCsvService.createNotNestedPropertiesExportData;
    }
  }
  return {
    isReadOnly: isReadOnly,
    isShowSelectionCheckboxes: isShowSelectionCheckboxes,
    getSettings: getSettings,
    prepareSearchCriteria: prepareSearchCriteria,
    getAttributes: getAttributes,
    getAttributesForDuplicateValidation: getAttributesForDuplicateValidation,
    getAttributesByType: getAttributesByType,
    getConfigProperty: getConfigProperty,
    getCsvExportOrder: getCsvExportOrder,
    getExportDataFunction: getExportDataFunction
  };
};
AdvancedHepGridService.$inject = ['Restangular', 'GridSettingsFactory', 'SearchCriteriaRuleFactory', 'ConfigurationService', 'ConfigurationParametersAdvancedService', 'AdvancedHepExportToCsvService', 'FeatureToggleService'];
module.exports = AdvancedHepGridService;